/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-nested-ternary */
/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import cookies from 'react-cookies';
import Modal from 'react-modal';
import {
  BodyDetailsClient,
  TitleDetailsClient,
  DetailsContent,
  Title,
  Bottom,
  ModalConfirm,
  BodyDetails,
  LeftDetails,
  RightDetails,
  DetailsClient,
} from './styles';
import Skeleton from '../../../styles/skeleton';
import './styles.css';
import like from '../../../assets/icons/like.svg';
import unlike from '../../../assets/icons/unlike.svg';
import { LoaderIcon } from '../../Loader';
import api from '../../../services/api';
import BackButton from '../../BackButton';

interface iDTO {
  id?: string | undefined;
}
export interface dataServerDTO {
  created_at: string;
  creditor: dataTableInfo;
  debtor: dataTableInfo;
  due_date: string;
  total_value: string;
  id: number;
  percentage_value: string;
  status: string;
  updated_at?: string;
  proposal_type: 'registrar' | 'split';
}

export interface dataTableInfo {
  affiliation_key: string;
  document: string;
  fantasy_name: string;
  id: number;
  legal_name: string;
  on_registry: boolean;
  stone_code: string;
}
const backgroundStyle = {
  content: {
    background: 'red',
  },
};

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    borderRadius: '8',
    background: 'rgba(0,0,0,0)',
    border: 'none',
    padding: '-100px',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

Modal.setAppElement('#root');

const Accept = () => {
  const [titleModal, setTitleModal] = useState('Status');
  const [colorTitleModal, setColorTitleModal] = useState('#dcdcdc');
  const { id: idFilter } = useParams<iDTO>();
  const [modalIsOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const [dataContract, setDataContract] = useState<dataServerDTO>();

  const [fantasyName, setFantasyName] = useState<string>();
  const [socialName, setSocialName] = useState<string>();
  const [document, setDocument] = useState<string>();
  const [stoneCode, setStone] = useState<string>();
  const [isOnRegistrar, setIsOnRegistrar] = useState<boolean>(false);

  useEffect(() => {
    if (dataContract && cookies.load('external_tags')) {
      if (cookies.load('external_tags').gps_recebedor) {
        setSocialName(dataContract.debtor.legal_name);
        setFantasyName(dataContract.debtor.fantasy_name);
        setDocument(dataContract.debtor.document);
        setStone(dataContract.debtor.stone_code);
      } else if (cookies.load('external_tags').gps_originador) {
        setSocialName(dataContract.creditor.legal_name);
        setFantasyName(dataContract.creditor.fantasy_name);
        setDocument(dataContract.creditor.document);
        setStone(dataContract.creditor.stone_code);
      }
      setIsOnRegistrar(dataContract.proposal_type === 'registrar')
    }
  }, [dataContract]);

  useEffect(() => {
    async function findId() {
      const idProposal = idFilter;
      if (idProposal) {
        const response = await api.get(
          `/v0/gps/merchants/${cookies.load(
            'external_stone_codes',
          )}/proposals/${idProposal}`,
          {
            headers: {
              Authorization: `Bearer ${cookies.load('external_token')}`,
            },
          },
        );
        // eslint-disable-next-line consistent-return
        if ((idFilter && response.status === 200) || response.status === 204) {
          if (cookies.load('external_tags'))
            if (cookies.load('external_tags').gps_recebedor) {
              setDataContract(response.data);
            } else if (cookies.load('external_tags').gps_originador) {
              setDataContract(response.data);
            }
        } else {
          alert(response.statusText);
        }
      }
    }
    findId();
  }, [idFilter]);

  async function handleProposal(type: number) {
    setLoading(true);
    if (type === 1) {
      setTitleModal('Aceita');
      setColorTitleModal('#0DB14B');
      try {
        const response = await api.post(
          `/v0/gps/merchants/${cookies.load(
            'external_stone_codes',
          )}/proposals/${idFilter}/accept`,
          {},
          {
            headers: {
              Authorization: `Bearer ${cookies.load('external_token')}`,
            },
          },
        );
        if (response.status === 200 || response.status === 204) {
          setIsOpen(true);
          setLoading(false);
        } else {
          history.push('/notconnected');
        }
      } catch (error) {
        history.push('/notconnected');
      }
    } else if (type === 0) {
      setTitleModal('Rejeitada');
      setColorTitleModal('#ff574d');
      try {
        const response = await api.post(
          `/v0/gps/merchants/${cookies.load(
            'external_stone_codes',
          )}/proposals/${idFilter}/reject`,
          {},
          {
            headers: {
              Authorization: `Bearer ${cookies.load('external_token')}`,
            },
          },
        );
        if (response.status === 200 || response.status === 204) {
          setIsOpen(true);
          setLoading(false);
        }
      } catch (error) {
        history.push('/notconnected');
        setLoading(true);
      }
    }
  }

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    // subtitle.style.color = '#f00';
  }
  function closeModal() {
    setIsOpen(false);
  }
  function statusText(status: string | undefined) {
    switch (status) {
      case 'AP':
        return 'Aprovada';
      case 'RE':
        return 'Rejeitada';
      case 'PE':
        return 'Pendente';
      case 'ED':
        return 'Edição';
      case 'DI':
        return 'Desabilitada';
      default:
        return 'Carregando';
    }
  }
  function statusColor(status: string | undefined) {
    switch (status) {
      case 'AP':
        return '#0DB14B';
      case 'RE':
        return '#E01342';
      case 'PE':
        return '#FDCE08';
      case 'DI':
        return '#FDCE08';
      default:
        return '#DCDCDC';
    }
  }
  return (
    <DetailsContent>
      <Title>
        <span
          style={{
            color: '#0DB14B',
            fontFamily: 'Roboto',
            fontWeight: 500,
          }}
        >
          {`Proposta #${`00000${idFilter}`.slice(-5)}`}
        </span>
        <div
          id="btnBack"
          style={{
            display: 'flex',
            flex: 1,
            height: 1,
            background: '#0DB14B',
            marginRight: 20,
            marginLeft: 20,
          }}
        />
        <BackButton adress="/" />
      </Title>
      <BodyDetails>
        <LeftDetails>
          <DetailsClient>
            <TitleDetailsClient>
              {cookies.load('external_tags').gps_recebedor
                ? 'Detalhes do Lojista'
                : cookies.load('external_tags').gps_originador
                ? 'Detalhes do Fornecedor'
                : ''}
            </TitleDetailsClient>
            <BodyDetailsClient>
              <span>Nome Fantasia</span>
              {fantasyName ? (
                <label>{fantasyName}</label>
              ) : (
                <Skeleton
                  style={{
                    width: 200,
                    height: 30,
                    borderRadius: 4,
                    marginBottom: 20,
                  }}
                />
              )}
              <span>Nome Social</span>
              {socialName ? (
                <label>{socialName}</label>
              ) : (
                <Skeleton
                  style={{
                    width: 180,
                    height: 30,
                    borderRadius: 4,
                    marginBottom: 20,
                  }}
                />
              )}
              <span>CPF/CNPJ</span>
              {document ? (
                <label>{document}</label>
              ) : (
                <Skeleton
                  style={{
                    width: 220,
                    height: 30,
                    borderRadius: 4,
                    marginBottom: 20,
                  }}
                />
              )}
              {!isOnRegistrar && (
                <>
                  <span>Stone Code</span>
                  {stoneCode ? (
                    <label>{stoneCode}</label>
                  ) : (
                    <Skeleton
                      style={{
                        width: 170,
                        height: 30,
                        borderRadius: 4,
                        marginBottom: 20,
                      }}
                    />
                  )}
                </>
              )}
              <span>Status</span>
              {stoneCode ? (
                <label>
                  {statusText(dataContract?.status)}
                  <div
                    style={{
                      width: 10,
                      height: 10,
                      borderRadius: 10,
                      marginLeft: 5,
                      background: statusColor(dataContract?.status),
                    }}
                  />
                </label>
              ) : (
                <Skeleton
                  style={{
                    width: 150,
                    height: 30,
                    borderRadius: 4,
                    marginBottom: 20,
                  }}
                />
              )}
            </BodyDetailsClient>
          </DetailsClient>
        </LeftDetails>
        <Modal
          isOpen={modalIsOpen}
          onAfterOpen={afterOpenModal}
          onRequestClose={closeModal}
          style={customStyles}
          contentLabel="Example Modal"
          overlayClassName="Overlay"
        >
          <ModalConfirm
            style={{
              background: `${colorTitleModal}`,
              border: '2px solid #dcdcdc',
            }}
          >
            {titleModal === 'Rejeitada' ? (
              <img
                alt="Status"
                src={unlike}
                style={{ width: 80, height: 100 }}
              />
            ) : titleModal === 'Aceita' ? (
              <img alt="Status" src={like} style={{ width: 80, height: 100 }} />
            ) : (
              <div />
            )}

            <h2 style={{ color: '#fff', fontSize: 36, textAlign: 'center' }}>
              Proposta
              <br />
              {titleModal}
            </h2>
            {titleModal === 'Rejeitada' ? (
              <div style={{ textAlign: 'center', fontSize: 20, color: '#fff' }}>
                Esta proposta foi rejeitada.
                <br />E ela não afetará suas vendas.
              </div>
            ) : titleModal === 'Aceita' ? (
              <div style={{ textAlign: 'center', fontSize: 20, color: '#fff' }}>
                Esta proposta foi aceita.
                <br /> E ela passa a vigorar a partir de sua próximas vendas.
              </div>
            ) : (
              <div>Sem Status</div>
            )}
            <Bottom>
              <button
                type="button"
                style={{
                  background: '#fff',
                  border: 'none',
                  color: colorTitleModal,
                }}
                onClick={() => {
                  history.push('/');
                }}
              >
                Entendi
              </button>
            </Bottom>
          </ModalConfirm>
        </Modal>
        <RightDetails>
          <TitleDetailsClient>Detalhes da Proposta</TitleDetailsClient>
          <BodyDetailsClient>
            <Title>
              <div>
                <span>Valor Limite(opcional)</span>
                {stoneCode ? (
                  <label>{`R$ ${dataContract?.total_value || '00,00'}`}</label>
                ) : (
                  <Skeleton
                    style={{
                      width: 106,
                      height: 30,
                      borderRadius: 4,
                      marginBottom: 20,
                    }}
                  />
                )}
              </div>
              <div>
                <span>Data limite </span>
                {stoneCode ? (
                  <label>
                    {`${dataContract?.due_date.substring(8, 10) || '00'}/${
                      dataContract?.due_date.substring(5, 7) || '00'
                    }/${dataContract?.due_date.substring(0, 4) || '0000'}`}
                  </label>
                ) : (
                  <Skeleton
                    style={{
                      width: 106,
                      height: 30,
                      borderRadius: 4,
                      marginBottom: 20,
                    }}
                  />
                )}
              </div>
            </Title>
            <Title>
              <h4>Direcionamento</h4>
              <h4>Valor / Porcentagem</h4>
            </Title>
            <Title>
              <div>
                <h4>
                  <span>Todos os Direcionamentos</span>
                </h4>
                <h4>
                  <span>
                    Este direcionamento será atribuído para todos os arranjos
                    (bandeiras e modalidades).
                  </span>
                </h4>
              </div>
              {stoneCode ? (
                <label> {dataContract?.percentage_value}%</label>
              ) : (
                <Skeleton
                  style={{
                    width: 70,
                    height: 30,
                    borderRadius: 4,
                    marginBottom: 20,
                  }}
                />
              )}
            </Title>
            {loading ? (
              <Bottom>
                <LoaderIcon />
              </Bottom>
            ) : (
              <Bottom>
                <button
                  type="button"
                  onClick={() => {
                    handleProposal(0);
                  }}
                >
                  Rejeitar
                </button>
                <button
                  type="button"
                  onClick={() => {
                    handleProposal(1);
                  }}
                >
                  Aceitar
                </button>
              </Bottom>
            )}
          </BodyDetailsClient>
        </RightDetails>
      </BodyDetails>
    </DetailsContent>
  );
};
export default Accept;
